<template>
	<div class="l-body">
		<Top/>
		<div class="wrap sun" >
			<div class="l-wrap zheng">
				<div class="faqtit"><span id="game">奇迹世界SUN</span><span>-</span><span id="faqtype">贵宾服务</span></div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow1">
					<router-view/>
				</div>
				<div class="sp tcs1" v-show="qq">
							<div class="spinners bs02">
								<i id="colose" @click="tv"></i>
								<div class="tc_zhengwen">
							<h1 class="tcbiaoti">贵宾专属通道</h1>
							<div class="tczwtxt tczwt1">
								<li><p>电话服务：13861174102</p></li>
								<li><p>企业QQ：800103377</p><span><a href="tencent://message/?uin=800103377&Site=Sambow&Menu=yes">打开QQ服务</a></span></li>
								<li><p>贵宾专用邮箱：guibin@zhaouc.com</p></li>
								<li><p>接待时间：365*24小时在线贵宾专属通道</p></li>
							</div>
								</div>
				  </div>
				</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow">
					<h1><span id="game">奇迹世界SUN</span><span>-</span><span id="faqtype">贵宾服务</span></h1>
					<h2>customer service</h2>
					<div class="wentilist" style="width:90%;margin-left:55px">
						<ul id="nav">
						<li class="list"><i></i><a @click="t('/sun_vip/sun24')"><h3>贵宾特权说明</h3></a></li>
						<li class="list"><i></i><a @click="t('/sun_vip/vip')"><h3>常见问题说明</h3></a></li>
						<li class="list"><i></i><a @click="tt"><h3>贵宾专属通道</h3></a></li>
						<li class="list"><i></i><a @click="t('/sun_vip/vip1')"><h3>免费洗红申请</h3></a></li>
						<li class="list"><i></i><a @click="t('/sun_vip/vip2')"><h3>什么是贵宾用户</h3></a></li>
						</ul>
					</div>
					<div class="hujiao" style="float:left;">
						<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
						<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Top from '@/components/top.vue'
  export default {
    name: "sun_vip",
    components: {
      Top
    },
	data () {
	  return {
		theshow:true,
		theshow1:false,
    qq:false,
	  }
	},
	watch: {
		$route(to , from){
			if(to.path=='/sun_vip'){
				this.theshow=true
				this.theshow1=false
			}
		}
	 },
	methods:{
	  tt(){
		  this.qq=true
	  },
	  tv(){
		  this.qq=false
	  },
	  t(meg){
		  this.theshow=false
		  this.theshow1=true
		  this.$router.push({path:meg})
	  }
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/sun_vip.vue